import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号', width: 55},
    {key:'orgName', label: '部门', width: 100},
    {key:'employeeCode', label: '工号', width: 80},
    {key:'realName', label: '教师', width: 100},
  
    {key:'termName', label: '所属学期/学年', width: 130},
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 55},
    {key:'orgName', label: '部门', width: 100},
    {key:'employeeCode', label: '工号', width: 80},
    {key:'realName', label: '教师', width: 100},
  
    {key:'termName', label: '所属学期/学年', width: 130},
])

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else if(i === 'order') {
            params.push(`order=${keywords[i]}`)
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('listen/managerMonitor/queryNew?'+ params.join('&'), Object.assign({
        type: "course"
    }, defaultsParams, newKeyword))
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = [] 
        if(extParams && extParams.options.length > 0) {
            for(let i = 0; i < columnsArray.length; i++) {
                if(i === 5) {
                    extParams.options.forEach(o => {
                        newArray.push({
                            key: o.name,
                            label: o.value,
                            width: 100
                        })
                    })
                }
                newArray.push(columnsArray[i])
            }
        }
        return {
            data: response.payload.data,
            headers: utils.columns(newArray.length > 0 ? newArray :columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map(d => ({
            value: d.resultId,
            checked: false
        })),
        checked: false,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'jszgsubresult'+ url;
};

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    redirect,
    getSelection
}
